import React from 'react';
import { Header } from '../components/Header';
import { ProductGallery } from '../components/ProductGallery';
import { ProductInfo } from '../components/ProductInfo';
import { LongFormCopy } from '../components/LongFormCopy';
import { Bonuses } from '../components/Bonuses';
import { Footer } from '../components/Footer';
export function ProductPage() {
  return <div className="min-h-screen bg-ivory font-sans selection:bg-gold/30 selection:text-ink" data-id="element-121">
      <Header data-id="element-122" />

      <main data-id="element-123">
        {/* Hero Section - Product PDP Style */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-124">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-125">
            {/* Left Column: Images */}
            <div className="lg:sticky lg:top-32 h-fit" data-id="element-126">
              <ProductGallery data-id="element-127" />
            </div>

            {/* Right Column: Product Info */}
            <div data-id="element-128">
              <ProductInfo data-id="element-129" />
            </div>
          </div>
        </div>

        {/* Long Form Copy Section */}
        <LongFormCopy data-id="element-130" />

        {/* Bonuses Section */}
        <Bonuses data-id="element-131" />

        {/* Final CTA Section */}
        <div className="bg-ink py-24 text-center px-4 relative overflow-hidden" data-id="element-132">
          <div className="absolute inset-0 opacity-5" data-id="element-133">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,white_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-134"></div>
          </div>
          <div className="max-w-3xl mx-auto relative z-10" data-id="element-135">
            <span className="inline-block text-xs uppercase tracking-[0.2em] text-gold font-medium mb-6" data-id="element-136">
              Tu salud metabólica
            </span>
            <h2 className="text-4xl sm:text-5xl font-serif text-white mb-8 leading-tight" data-id="element-137">
              Empieza hoy mismo
            </h2>
            <p className="text-ivory/70 text-lg mb-12 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-138">
              Miles de personas buscan respuestas sobre los tratamientos con
              GLP-1. No permitas que la desinformación sea quien tome las
              decisiones por ti. Descubre la ciencia detrás de los péptidos y
              aprende a diferenciar los mitos de la evidencia.
            </p>
            <a href="https://newdigitalguide.com/products/peptidos-glp-1-y-perdida-de-peso-guia-educativa" className="inline-block bg-gold text-ink font-medium tracking-[0.2em] uppercase text-sm py-5 px-12 hover:bg-gold-hover transition-all duration-300 shadow-xl transform hover:-translate-y-0.5" data-id="element-139">
              Acceder Ahora
            </a>
          </div>
        </div>
      </main>

      <Footer data-id="element-140" />
    </div>;
}